var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuUnitSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.8001 4.79999C4.8001 3.47451 5.87461 2.39999 7.2001 2.39999H16.8001C18.1256 2.39999 19.2001 3.47451 19.2001 4.79999V19.2C19.8628 19.2 20.4001 19.7373 20.4001 20.4C20.4001 21.0627 19.8628 21.6 19.2001 21.6H15.4001C14.8478 21.6 14.4001 21.1523 14.4001 20.6V18C14.4001 17.3373 13.8628 16.8 13.2001 16.8H10.8001C10.1374 16.8 9.6001 17.3373 9.6001 18V20.6C9.6001 21.1523 9.15238 21.6 8.6001 21.6H4.8001C4.13736 21.6 3.6001 21.0627 3.6001 20.4C3.6001 19.7373 4.13736 19.2 4.8001 19.2V4.79999ZM8.4001 5.99999H10.8001V8.39999H8.4001V5.99999ZM10.8001 10.8H8.4001V13.2H10.8001V10.8ZM13.2001 5.99999H15.6001V8.39999H13.2001V5.99999ZM15.6001 10.8H13.2001V13.2H15.6001V10.8Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuUnitSelected);
export default __webpack_public_path__ + "static/media/menu-unit-selected.ad446774120c130c308ee57e205a881b.svg";
export { ForwardRef as ReactComponent };